import { InsuranceOverview } from 'Api/insurance';
import { ReactNode } from 'react';

export type LabelValuePair = {
  label: string;
  value: ReactNode;
  hide?: boolean;
};

export type TfaRegistry = {
  activeDate?: string;
  tfaCodes?: TfaCodes;
};

export type TfaCodes = {
  tfa100?: TfaPrice;
  tfa110?: TfaPrice;
  tfa200?: TfaPrice;
  tfa300?: TfaPrice;
  tfa400?: TfaPrice;
  tfa999?: TfaPrice;
  tfa000?: TfaPrice;
};

type TfaPrice = {
  monthly?: number;
  yearly?: number;
};

export type LevelCodes = {
  levelCode: string;
  value: string;
};

export type GValueDto = {
  _links: {
    self: {
      href: string;
    };
  };
  amount: string;
};

export type ChildTherapistView = {
  codes: Record<string, Record<string, string>>;
  description: string;
  title: string;
};

export enum TfaCodeKey {
  tfa000 = '000',
  tfa100 = '100',
  tfa200 = '200',
  tfa300 = '300',
  tfa400 = '400',
  tfa999 = '999',
}

export enum AKA_FAMILY_ACCIDENT_COVERAGE {
  AKA_FAMILY_ACCIDENT_DEATH = 'A+ Familieulykke død',
  AKA_FAMILY_ACCIDENT_DISABILITY = 'A+ Medisinsk invaliditet',
  AKA_FAMILY_ACCIDENT_DISABILITY_AND_PROFESSIONAL_DISABILITY = 'A+ Medisinsk invaliditet med faginvaliditet',
}

export enum AKA_FAMILY_ACCIDENT_COVERAGES_DITTO {
  AKA_FAMILY_ACCIDENT_DEATH = 'AKA_FAMILY_ACCIDENT_DEATH',
  AKA_FAMILY_ACCIDENT_DEATH_AND_DISABILITY = 'AKA_FAMILY_ACCIDENT_DEATH_AND_DISABILITY',
  AKA_FAMILY_ACCIDENT_DISABILITY = 'AKA_FAMILY_ACCIDENT_DISABILITY',
  AKA_FAMILY_ACCIDENT_DISABILITY_AND_PROFESSIONAL_DISABILITY = 'AKA_FAMILY_ACCIDENT_DISABILITY_AND_PROFESSIONAL_DISABILITY',
  AKA_FAMILY_ACCIDENT_DEATH_AND_DISABILITY_AND_PROFESSIONAL_DISABILITY = 'AKA_FAMILY_ACCIDENT_DEATH_AND_DISABILITY_AND_PROFESSIONAL_DISABILITY',
}

export enum INSURANCE_EVALUATION_TYPE {
  FIRST_RISK = 'FIRST_RISK',
  FULL_VALUE = 'FULL_VALUE',
}

export interface InsuranceOverviewResponse {
  insurance: InsuranceOverview | undefined;
  error: unknown;
  loading: boolean;
}
